import { ItineraryPoint, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type ItineraryPointPITOptions = ReqChangeId<ItineraryPointOptions>;
export const ItineraryPointPITKey = makePITKey<ItineraryPoint>(ItineraryPoint.key);
export const ItineraryPointPITDataKey = makePITDataKey<ItineraryPointOptions>(ItineraryPoint.dataKey);



// WEBPACK FOOTER //
// ./data/models/ItineraryPointPIT.ts